import { timeStamp } from 'console';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RecordModel } from '@app/layout/record-model';
import { ModuleStructure } from '@app/models/module-structure';
import { LayoutService } from '@app/layout/layout.service';
import * as g from 'src/app/globals';

@Component({
  selector: 'app-creation-success',
  templateUrl: './creation-success.component.html',
  styleUrls: ['./creation-success.component.less'],
})
export class CreationSuccessComponent implements OnInit {
  @Input() moduleStructure: ModuleStructure;
  @Input() recordModel: RecordModel;
  @Input() urlPrefix: string = '';
  @Input() moduleFilterId = 0;
  @Input() fromDraft = false;

  @Input() moduleId: number;

  recordIdVal: string | number;
  saveToFinalDocConfig: boolean;
  showSaveTofinalButtonConfig = true;
  @Input() set recordId(val: string | number) {
    this.recordIdVal = val;
  }

  get recordId(): string | number {
    return this.recordIdVal;
  }

  keyToDisplayVal: string;

  @Input() set keyToDisplay(val: string) {
    this.keyToDisplayVal = val;
  }

  get keyToDisplay(): string {
    return this.keyToDisplayVal;
  }

  messageToDisplay = '';

  constructor(private layoutService: LayoutService, private router: Router) {}

  ngOnInit(): void {
    this.messageToDisplay =
      this.moduleStructure.module.AdditionalInformationParsed.SuccessMessageAfterAdd;
    this.messageToDisplay = this.messageToDisplay.replace(
      '[DocNum]',
      this.keyToDisplay
    );
  }

  navigateToNew() {
    this.layoutService.createNewEmitter.emit('');
    this.layoutService.refreshListEmitter.emit('');

    this.router.navigate([
      `${this.urlPrefix}module-list/${this.moduleId}/${this.moduleFilterId}`,
      {
        newMode: true,
        fromDraft: this.fromDraft,
        timeStamp: new Date().getTime(),
      },
    ]);
  }

  viewRecord() {
    this.layoutService.createNewEmitter.emit('');
    this.layoutService.refreshListEmitter.emit('');

    this.router.navigate([
      `${this.urlPrefix}module-list/${this.moduleId}/${this.moduleFilterId}`,
      {
        newMode: false,
        fromDraft: this.fromDraft,
        selectedId: this.recordId,
      },
    ]);
  }

  backToList() {
    this.layoutService.createNewEmitter.emit('');
    this.layoutService.refreshListEmitter.emit('');

    this.router.navigate([
      `${this.urlPrefix}module-list/${this.moduleId}/${this.moduleFilterId}`,
      {
        fromDraft: this.fromDraft,
      },
    ]);
  }

  preview() {
    const url = `Report/PrintObject/${
      this.moduleStructure.module.LayoutDefinitionId
    }?selectedId=${
      this.recordId
    }&exportMode=5&mode=preview&${g.getUrlSuffix()}`;
    window.open(g.apiBaseUrl + url);
  }
}
